const CHIP_STYLE_TYPES = {
  TEXT: 'text',
  BG_TEXT: 'bg_text',
  ICON: 'icon',
};

export { CHIP_STYLE_TYPES };
